<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="d-sm-none"
           for="bezeichnung{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.MARKTPLAETZE.BEZEICHNUNG' | translate }}</label>
    <div class="col-sm-6">
      <input class="form-control" datevMessagePath="bezeichnung{{objectId}}" formControlName="bezeichnung"
             id="bezeichnung{{index}}" type="text"
             utilsCheckValidity utilsControlState
             utilsMarkRequired utilsValidationMessage/>
    </div>

    <label class="d-sm-none"
           for="identifikationsmerkmal{{index}}">{{ 'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.MARKTPLAETZE.IDENTIFIKATIONSMERKMAL' | translate }}</label>
    <div class="col-sm-6 position-relative">
      <input class="form-control" datevMessagePath="identifikationsmerkmal{{objectId}}" formControlName="identifikationsmerkmal"
             id="identifikationsmerkmal{{index}}" type="text"
             utilsCheckValidity
             utilsControlState utilsValidationMessage/>
      <div class="common-ui-remove-marktplatz-button">
        <button (click)="removeMarktplatz()" *ngIf="!readonly"
                class="btn btn-light btn-img" id="marktplatzEntfernen{{index}}"
                title="{{'COMMON_UI.FRAGEBOGEN.UMSAETZE_INTERNET.REMOVE_MARKTPLATZ' | translate }}"
                type="button">
          <em class="icon icon-svg icon-fi-loeschen"></em>
        </button>
      </div>
    </div>

  </div>

</form>
